import {Outlet} from '@github-ui/react-router'
import type {ReactNode} from 'react'

import {usePublishPayload} from './use-publish-payload'

/**
 * Wraps an optional App component around the outlet.
 */
export function AppWrapper({App}: {App?: AppComponentType}) {
  usePublishPayload()

  return App ? (
    <App>
      <Outlet />
    </App>
  ) : (
    <Outlet />
  )
}

export type AppComponentType = React.ComponentType<{children?: ReactNode}>

try{ AppWrapper.displayName ||= 'AppWrapper' } catch {}